import { render } from "./DashboardSystems.vue?vue&type=template&id=1bc4dd20&scoped=true&ts=true"
import script from "./DashboardSystems.vue?vue&type=script&lang=ts"
export * from "./DashboardSystems.vue?vue&type=script&lang=ts"

import "./DashboardSystems.vue?vue&type=style&index=0&id=1bc4dd20&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc4dd20"]])

export default __exports__